import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { MenuCategory } from 'types/menuCategory';
import {
  REGISTRATION_STEP,
  RegistrationStep,
} from '../../../constants/registrationStep';

/**
 * メニューカテゴリーの詳細画面の状態
 */
interface DetailState {
  /** ロード状態 */
  loading: boolean;
  /** 表示中のメニューカテゴリー */
  selected: MenuCategory | null;
  /** 削除確認モーダルの表示状態 */
  isOpenModalDelete: boolean;
  /** バージョン追加ステップ */
  step: RegistrationStep;
}

/**
 * メニューカテゴリー詳細画面の初期状態
 */
const initialState: DetailState = {
  loading: false,
  selected: null,
  isOpenModalDelete: false,
  step: REGISTRATION_STEP.INPUT,
};

/**
 * メニューカテゴリー詳細画面の slice(reducer + action)
 */
export const detailSlice = createSlice({
  name: 'detailMenuCategory',
  initialState,
  reducers: {
    initialize: () => initialState,
    updateLoadingStatus: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      loading: payload,
    }),
    modalOpened: (
      state,
      { payload }: PayloadAction<DetailState['selected']>,
    ) => ({
      ...state,
      selected: payload,
    }),
    updateIsOpenModalDelete: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      isOpenModalDelete: payload,
    }),
    updateStep: (state, { payload }: PayloadAction<DetailState['step']>) => ({
      ...state,
      step: payload,
    }),
  },
});

/**
 * メニューカテゴリー詳細画面の action
 */
export const detailActions = detailSlice.actions;

/**
 * メニューカテゴリー詳細画面の selectors
 */
export const detailSelectors = {
  selectedMenuCategory: (state: RootState) =>
    state.menuCategory.detail.selected,
  isOpenModalDelete: (state: RootState) =>
    state.menuCategory.detail.isOpenModalDelete,
  currentModalStep: (state: RootState) => state.menuCategory.detail.step,
} as const;
